/**
 * Equipment slot enum — ported from RSPK's src/config/constants.ts.
 * Values correspond to OSRS item_configs.json equipment_slot indices.
 */
export enum EquipSlot {
  HEAD = 0,
  CAPE = 1,
  NECK = 2,
  WEAPON = 3,
  BODY = 4,
  SHIELD = 5,
  LEGS = 7,
  HANDS = 9,
  FEET = 10,
  RING = 12,
  AMMO = 13,
}
